import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { setSessionToken } from '../../../store/actions/session';
import {
  resetCreateAccountData,
  setUserCreateAccountData,
} from '../../../store/actions/createAccountData';
import CreateAccount from '../../../components/Auth/CreateAccount/CreateAccount';
import paths from '../../../constants/paths';
import { gtmSignupStep } from '../../../assets/helpers/GAHelper';

const GTM_STEP = {
  1: 'gender',
  2: 'location',
  3: 'age',
  4: 'username',
  5: 'email-password',
};

class CreateAccountContainer extends Component {
  state = { showAlert: false, errorMessage: null, showSpinner: false };

  componentDidUpdate(prevProps) {
    // APPLE AUTH SUCCESS
    if (
      prevProps.appleAuth.status !== this.props.appleAuth.status &&
      this.props.appleAuth.status === 'success'
    ) {
      // console.log('Apple Login Success save Session Token ', this.props.appleAuth);
      this.props.setSessionToken(this.props.appleAuth.response.token);
    }
    // APPLE AUTH FAIL
    else if (
      prevProps.appleAuth.status !== this.props.appleAuth.status &&
      this.props.appleAuth.status === 'fail'
    ) {
      if (this.props.appleAuth.error.error_code !== 3) {
        this.toggleAlertError(this.props.appleAuth.error.error);
      }
    }
  }

  goBack = () => {
    const { step } = this.props.createAccountData;
    if (step === 1) {
      if (this.props.history.action === 'PUSH') {
        this.props.history.goBack();
      } else {
        this.props.history.push(paths.INDEX);
      }
      this.props.resetCreateAccountData();
    } else {
      if (step > 1) {
        gtmSignupStep(GTM_STEP[step - 1], step, 5);
      }
      this.props.setUserCreateAccountData({ step: step - 1 });
    }
  };

  goToStep = (step) => {
    if (step !== 0) {
      gtmSignupStep(GTM_STEP[step], step, 5);
    }
    this.props.setUserCreateAccountData({ step });
  };

  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  render() {
    return (
      <CreateAccount
        showSpinner={this.state.showSpinner}
        showErrorAlert={this.state.showAlert}
        errorAlertMessage={this.state.errorMessage}
        dismissAlert={this.toggleAlertError}
        isLandscape={this.props.isLandscape}
        step={this.props.createAccountData.step}
        goToStep={this.goToStep}
        goBack={this.goBack}
        showLanguageSwitch={this.props.history.action !== 'PUSH'}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    myLocation: state.myLocation,
    createAccountData: state.createAccountData,
    appleAuth: state.appleAuth,
    getConfig: state.getConfig,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setSessionToken,
      setUserCreateAccountData,
      resetCreateAccountData,
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateAccountContainer);



// WEBPACK FOOTER //
// ./src/containers/Auth/CreateAccount/CreateAccountContainer.js